import React from 'react';
import { strings } from '/imports/strings';
import { useFind, useSubscribed, useUser } from '/imports/hooks';
import { Publications } from '/imports/publications';
import { MessageReceipts } from '/imports/api/messages';
import { Icon } from '/imports/ui/Icon';

/** Nav item showing a chat icon with an unread-message count badge. */
export const MessagesNavItem = () => {
  const user = useUser();
  const userId = user?._id;
  const loading = useSubscribed(Publications.unreadMessageReceipts);
  const unreads = useFind(() => MessageReceipts.find({ userId }), [userId, loading]);
  const numItems = unreads.length;
  return (
    <>
      <Icon icon="chat" />
      <span className="text">{strings.Messages()}</span>
      {numItems && <span className="badge">{numItems}</span> || null}
    </>
  );
};